import React, { useState } from 'react';
import { domain } from '../../../../Urls/Services/Api_urls';
import Swal from 'sweetalert2';
import { DocSearch } from 'iconoir-react';

export const DocumentSol = (props) => {
    const { planes, tableMeta } = props;
   
    const [price_plan, setPrice] = useState(tableMeta.price_plan);
    const [id_plan, setId_plan] = useState(tableMeta.id_plan);
    const [id_plan_open, setId_plan_open] = useState(tableMeta.id_plan_open);
    const [plan_type, setPlan_type] = useState(tableMeta.plan_type);
    const [plan, setPlan] = useState(tableMeta.plan);

    const token = window.sessionStorage.getItem("token");
    const groups = window.sessionStorage.getItem("groups");
    


    const campoArchivo = (ruta) => {
        const nombre = ruta ? decodeURIComponent(ruta.split("/").pop()) : "";
        return `
        <style>.btn-archivo{background-color:#e9ecef;color:#212529;border:1px solid #ced4da;border-radius:.375rem 0 0 .375rem;}.btn-archivo:hover:not(:disabled){background-color:#d3d9df;color:#212529;}.btn-archivo:focus-visible,.btn-archivo:active{background-color:#e9ecef;color:#212529;border-color:#ced4da;}</style>
        <div class="input-group mb-4">
            <button type="button" class="btn btn-archivo">Cargar archivo</button>
            <div class="form-control" style="text-align:left; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                ${nombre ? `<a target="_blank" href="${domain}${ruta}">${nombre}</a>` : `<span style="color:#6c757d">Seleccionar archivo</span>`}
            </div>
        </div>`;
    };

    const allowedStatus = new Set(["Orden creada"]);
    const allowedGroups2 = new Set(["vendedor_PAP", "Usuario"]);


    const handleSubmit = () => {
        const headers = new Headers({
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        });

        fetch(`${domain}/portal/${tableMeta.id}/`, { method: "GET", headers })
            .then(response => response.json())
            .then(result => Swal.fire({
                title: "Ver datos de la Solicitud",
                html: `
                    <form>
                        <div class="m-3">
                            <div class="row mb-3">
                                <div class="col-6">
                                    <label for="NameLabelUpdate" class="labelFount">Nombre</label>
                                    <input type="text" id="swal-name-input" class="form-control" placeholder="Nombre" value="${tableMeta.name}" disabled>
                                </div>
                                <div class="col-6">
                                    <label for="NameLabelUpdate" class="labelFount">Apellido</label>
                                    <input type="text" id="swal-last_name-input" class="form-control" placeholder="Apellido" value="${tableMeta.last_name}" disabled>
                                </div>
                                <div class="col-6">
                                    <label for="NameLabelUpdate" class="labelFount" style="margin-top: 1rem;">Documento</label>
                                    <input type="text" id="swal-input2" class="form-control" placeholder="DNI Propietario" value="${tableMeta.cc}" style="width: 100%; height: 2.2rem; margin-bottom: 1.5rem;" disabled>
                                </div>
                                <div class="col-6">
                                    <label for="NameLabelUpdate" class="labelFount">CEL Propietario</label>
                                    <input type="text" id="swal-input3" class="form-control" placeholder="CEL Propietario" value="${tableMeta.contact_phone}" disabled>
                                </div>
                            </div>
                            <div class="mb-4">
                                <label for="NameLabelUpdate" class="labelFount">Dirección Propietario</label>
                                <input type="text" id="swal-input4" class="form-control" 
                                    ${groups === "Backoffice" || groups === "facilitador_comercial" ? "" : "disabled"} 
                                    placeholder="Dirección Propietario" value="${tableMeta.address}">
                            </div>
                            <div class="mb-4">
                                <label for="NameLabelUpdate" class="labelFount">Email</label>
                                <input type="text" id="swal-input4" class="form-control" disabled placeholder="Email" value="${tableMeta.email_owner}">
                            </div>
                            <div class="mb-4">
                            <label for="NameLabelUpdate" class="labelFount">Tipo Solicitud</label>
                            <input type="number" id="swal-input8" disabled class="form-control" placeholder="Contrato" value="${tableMeta.type_service}">
                                
                                <label for="NameLabelUpdate" class="labelFount">Estrato</label>
<input type="number" id="swal-input8" disabled class="form-control" placeholder="Contrato" value="${tableMeta.estrato}">
                                
                            </div>
                            <label for="NameLabelUpdate" class="labelFount">Adjuntar recibo publico</label>
                            ${campoArchivo(tableMeta.rec_pub)}
                            <label for="NameLabelUpdate" class="labelFount">Adjuntar cedula (cara frontal)</label>
                            ${campoArchivo(tableMeta.ad_cc)}
                            <label for="NameLabelUpdate" class="labelFount">Adjuntar cedula (cara posterior)</label>
                            ${campoArchivo(tableMeta.ad_cc_back)}
                            <div class="mb-4">
                                <label for="NameLabelUpdate" class="labelFount">Plan</label>
                                <input type="text" id="swal-input3" class="form-control" placeholder="CEL Propietario" value="${tableMeta.plan}" disabled>
                                
                                <label for="NameLabelUpdate" class="labelFount">Precio</label>
                                <input type="text" id="swal-price-input" disabled class="form-control" placeholder="Precio" value="${price_plan}">
                                <input type="text" id="swal-Plan-input" disabled class="form-control" style="display:none" value="${plan}">
                                <input type="text" id="swal-idplan-input" disabled class="form-control" style="display:none" value="${id_plan}">
                                <input type="text" id="swal-idopen-input" disabled class="form-control" style="display:none" value="${id_plan_open}">
                                <input type="text" id="swal-typeplan-input" disabled class="form-control" style="display:none" value="${plan_type}">
                            </div>
                            <div class="col-12">
                                <label for="NameLabelUpdate" class="labelFount">Contrato</label>
                                <input type="number" id="swal-input8" disabled class="form-control" placeholder="Contrato" value="${tableMeta.contract}">
                            </div>
                            <div class="row mb-4">
                                <label for="NameLabelUpdate" class="labelFount">Observaciones</label>
                                <textarea id="swal-input7" class="form-control" rows="5" placeholder="Para hacer saltos de linea presionar ENTER" disabled>${tableMeta.observations}</textarea>
                            </div>
                        </div>
                    </form>
                `,
                focusConfirm: false,
                
            }))
            .catch(error => console.log("error", error));
    };

    return (
        <>
            {allowedStatus.has(tableMeta.is_actived) && (

                <button
                    className='p-1 cursor-pointer bg-blue-700 hover:bg-blue-600 text-white rounded-md '
                    onClick={handleSubmit}
                    title="Ver documentos"
                >
                    <DocSearch />
                </button>
            )}
        </>
    );
};